import { bootToolPage } from '../lib/boot-tool'
import { collectMetrics, metricsSummary } from '../lib/metrics'
import { SITE_VERSION } from '../site'

bootToolPage('report')

const report = {
  version: SITE_VERSION,
  createdAt: new Date().toISOString(),
  metrics: collectMetrics(),
  wizard: safeParse(localStorage.getItem('sd.wizard')),
}

const out = document.querySelector('[data-report-out]')
const text = `${metricsSummary(report.metrics)}\n\n${JSON.stringify(report, null, 2)}`
if (out) out.textContent = text
const set = (selector: string, value: string) => {
  const node = document.querySelector(selector)
  if (node) node.textContent = value
}
set('[data-report-screen]', `${report.metrics.cssWidth}×${report.metrics.cssHeight}`)
set('[data-report-dpr]', String(report.metrics.dpr))
set('[data-report-gamut]', report.metrics.colorGamut.toUpperCase())

document.querySelector('[data-action="copy-report"]')?.addEventListener('click', async () => {
  await navigator.clipboard.writeText(text)
  const button = document.querySelector<HTMLButtonElement>('[data-action="copy-report"]')
  if (!button) return
  const label = button.textContent
  button.textContent = '✓'
  window.setTimeout(() => {
    button.textContent = label
  }, 1200)
})

document.querySelector('[data-action="download-report"]')?.addEventListener('click', () => {
  const blob = new Blob([JSON.stringify(report, null, 2)], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `screen-detect-report-${Date.now()}.json`
  a.click()
  URL.revokeObjectURL(url)
})

function safeParse(raw: string | null): unknown {
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}
